import { Component, Input } from '@angular/core';

@Component({
    selector: 'fcp-breadcrumbs',
    templateUrl: './fcp-breadcrumbs.component.html',
    styleUrls: ['./fcp-breadcrumbs.component.less'],
    standalone: false
})
export class FcpBreadcrumbsComponent {
    @Input() list: Array<LinkItem> = [];
    @Input() size?: 'small' | 'medium' = 'medium';

    private MAX_LABEL_LENGTH = 26;
    private MAX_LIST_LENGTH = 6;

    public isLastItem(index: number) {
        return index === this.formattedList.length - 1;
    }

    public get formattedList(): Array<LinkItem> {
        const formattedLabelsList = this.list.map((item) => {
            const hasOverflow = item.label.length > this.MAX_LABEL_LENGTH;

            return {
                label: hasOverflow ? `${item.label.slice(0, this.MAX_LABEL_LENGTH - 3)}...` : item.label,
                url: item.url
            };
        });

        if (formattedLabelsList.length < this.MAX_LIST_LENGTH) {
            return formattedLabelsList;
        }

        const firstItem = formattedLabelsList[0];
        const length = formattedLabelsList.length;
        const lastTwoItems = formattedLabelsList.slice(length - 2, length);
        const ellipsisItem: LinkItem = { label: '...', url: '' };

        return [firstItem, ellipsisItem, ...lastTwoItems];
    }
}

export interface LinkItem {
    label: string;
    url: string;
}
